/**
 * Page où revenir après connexion (`/login?redirect=/cart`).
 *
 * Seul un chemin interne est accepté : `//site.com` ou `https://…` feraient
 * de la page de connexion un tremplin vers un autre site, à partir d'un lien
 * piégé. Dans ce cas, on retombe sur la page d'accueil prévue.
 */
export function safeRedirect(value: string | null | undefined): string | null {
  if (!value) return null;
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null;
  return value;
}

/** Lien vers une page de connexion qui ramène ensuite à `path`. */
export function withRedirect(loginPath: string, path: string): string {
  return `${loginPath}?redirect=${encodeURIComponent(path)}`;
}
